export default __webpack_public_path__ + "37199b265e4159046b728a4bd01631c0.svg";